import { useAppSelector, useAppDispatch } from "store/hooks";
import { useEffect } from "react";
import { setActivePaginationPage } from "@global-state/pages/admin/myProxies/slice";
import style from "./TableBody.module.scss";
import { IProxy } from "@interfaces/admin/proxy";
import { useGetAllProxiesQuery } from "@RTKQuery/admin/proxy/proxy";
import { RiLoader5Fill } from "react-icons/ri";

export function TableBody({
    children
}: {
    children: (data: IProxy) => JSX.Element
}) {
    const { activeSortParameter, activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeSearchPhoneParameter, activeOperator, activeSelling } = useAppSelector(state => state.myProxiesAdminPage);


    const { currentData: data, isFetching, isError, refetch } = useGetAllProxiesQuery({
        page: activePaginationPage,
        limit: activePaginationLimit,
        router_id: activeSearchIdParameter,
        operator: activeOperator,
        phone_number: activeSearchPhoneParameter,
        selling: activeSelling
    });

    const dispatch = useAppDispatch();
    useEffect(() => {
        if (!data || isFetching || isError) return;
        const lastPage = Math.max(1, Math.ceil(data.count_items / activePaginationLimit));
        if (activePaginationPage > lastPage) dispatch(setActivePaginationPage(lastPage));
    }, [data, isFetching, isError, activePaginationLimit, activePaginationPage, dispatch]);

    const sortedArr = [...data?.parent_proxies || []]

    if (activeSortParameter === "term") {
        sortedArr.sort((a, b) => {
            return (new Date(a.pay_date || "").getTime() || 0) - (new Date(b.pay_date || "").getTime() || 0)
        })
    }

    return (
        <div className={style.body}>
            {
                isFetching
                    ? <div className={style.empty}><RiLoader5Fill className="animate-spin w-[30px] h-[30px]" /></div>
                    : isError
                        ? <div role="alert" className={style.empty}>Не вдалося завантажити модеми.
                            <button type="button" onClick={() => refetch()} className="ml-2 underline">Спробувати ще раз</button>
                        </div>
                        : sortedArr.length ? sortedArr.map(row => children(row))
                            : <div className={style.empty}>Модемів не знайдено</div>
            }
        </div>
    )
}
